import { render, staticRenderFns } from "./AdminSettings.vue?vue&type=template&id=8f174a5e&scoped=true"
import script from "./AdminSettings.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminSettings.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AdminSettings.vue?vue&type=style&index=0&id=8f174a5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f174a5e",
  null
  
)

export default component.exports